import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";

import { CreateShipmentFormContainer } from "components/Shipper/components/CreateShipmentForm/CreateShipmentFormContainer";
import { useShipperShipmentPageContext } from "hooks";

import type { CreateShipmentFormState } from "types/shipment";

interface Props {
  onClose: VoidFunction;
  error: string | null;
  shipmentState: CreateShipmentFormState | undefined;
}

export function ShipmentCopyModal(props: Props) {
  const { onClose, error, shipmentState } = props;
  const { onRefresh } = useShipperShipmentPageContext();

  const onShipmentPosted = () => {
    if (onRefresh) {
      onRefresh();
    }
    onClose();
  };
  return (
    <Dialog open onClose={onClose} maxWidth="md" style={{ height: "90%" }}>
      <DialogContent>
        <CreateShipmentFormContainer
          shipmentState={shipmentState}
          error={error}
          postShipmentUrl="/shipments"
          onSubmitShipmentSuccessCallback={onShipmentPosted}
          showShareMenu
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
